import { stringifyQs } from "@saleor/utils/urls";

import { SaleUser } from "../hooks/useSaleUserType";
import { saleAddUrl, SaleListUrlQueryParams } from "../urls";

export default function getSaleAddUrlByUserType(
  saleUser: SaleUser,
  params: SaleListUrlQueryParams
) {
  const brandParam = { brand: params.brand };

  if (saleUser.isKAMS) {
    return `${saleAddUrl}?${stringifyQs(brandParam)}`;
  }
  return saleAddUrl;
}
